import PropTypes from 'prop-types';

function MMGlutenFreeActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_1721_47811)">
                <path
                    d="M4.97919 12.5915C4.97919 12.5915 5.2958 14.303 7.72606 15.2314C10.1563 16.1599 11.2302 15.0603 11.2302 15.0603C10.8265 13.971 10.0234 13.0761 8.98397 12.5573C7.19551 11.7101 4.97919 12.5915 4.97919 12.5915Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.8104 8.78418C13.8104 8.78418 12.0989 9.10508 11.1705 11.5353C10.242 13.9656 11.3416 15.0395 11.3416 15.0395C12.4319 14.6351 13.327 13.8303 13.8446 12.789C14.6918 11.0005 13.8104 8.78418 13.8104 8.78418Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.63947 6.74695C6.63947 6.74695 14.525 25.5729 15.877 27.5924C16.1209 27.9475 17.7125 28.5251 17.5884 26.788C17.5157 25.8681 8.36803 5.98535 8.36803 5.98535L6.63947 6.74695Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.9379 15.9375C16.9379 15.9375 15.2265 16.2541 14.298 18.6844C13.3353 21.1788 14.4691 22.1928 14.4691 22.1928C15.5594 21.7885 16.4546 20.9836 16.9721 19.9423C17.8193 18.1624 16.9379 15.9375 16.9379 15.9375Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.6306 3.6582C11.1171 3.65736 8.65979 4.40192 6.5695 5.79772C4.4792 7.19352 2.84978 9.17787 1.88733 11.4998C0.924871 13.8217 0.67261 16.3769 1.16245 18.8422C1.65229 21.3075 2.86222 23.5721 4.63922 25.3497C6.41622 27.1273 8.68047 28.338 11.1456 28.8287C13.6107 29.3194 16.166 29.068 18.4882 28.1063C20.8105 27.1446 22.7954 25.5159 24.1919 23.426C25.5884 21.3362 26.3338 18.8792 26.3338 16.3657C26.3338 12.9962 24.9955 9.76465 22.6133 7.38165C20.2312 4.99866 17.0001 3.65934 13.6306 3.6582ZM16.1507 14.5216C17.5883 13.3621 21.7984 9.32309 21.7984 9.32309C22.0338 9.60976 22.9665 10.8719 23.0478 11.0345C23.983 12.6819 24.4698 14.5456 24.4599 16.4399C24.4499 18.3341 23.9434 20.1927 22.9909 21.8301C22.0384 23.4675 20.6733 24.8265 19.0316 25.7716C17.3899 26.7167 15.5291 27.2148 13.6348 27.2163C10.5371 27.2163 7.4608 25.4021 5.50547 23.3227C5.36 23.173 9.27921 20.2122 9.27921 20.2122C9.27921 20.2122 14.4221 15.9378 16.1507 14.5216ZM4.22189 21.2904C3.40895 20.1908 2.79711 18.0172 2.79711 16.3657C2.79825 13.4932 3.94012 10.7388 5.97167 8.70805C8.00321 6.67731 10.7581 5.53652 13.6306 5.53652C16.0523 5.53652 18.5082 6.79871 20.0955 8.22776L4.22189 21.2904Z"
                    fill="#DC6C31"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.1481 8.27013C3.1481 8.27013 3.469 9.98158 5.89925 10.91C8.3295 11.8385 9.40344 10.7389 9.40344 10.7389C8.99906 9.64859 8.19422 8.75348 7.15288 8.2359C5.36442 7.38018 3.1481 8.27013 3.1481 8.27013Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.10681 19.7498C8.10681 19.7498 8.42343 21.4612 10.8537 22.394C13.2839 23.3267 14.3579 22.2228 14.3579 22.2228C13.9529 21.1318 13.1484 20.2355 12.1073 19.7156C10.3402 18.8727 8.10681 19.7498 8.10681 19.7498Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.9834 4.46191C11.9834 4.46191 10.2719 4.78281 9.33919 7.21306C8.40645 9.64332 9.51462 10.7172 9.51462 10.7172C10.6049 10.3129 11.5 9.50804 12.0176 8.4667C12.8648 6.67824 11.9834 4.46191 11.9834 4.46191Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.54834 2.78125C5.54834 2.78125 4.67123 4.27877 5.89919 6.57638C7.12715 8.874 8.66745 8.73708 8.66745 8.73708C9.07289 7.64666 9.04842 6.44285 8.59899 5.36981C7.79889 3.56424 5.54834 2.78125 5.54834 2.78125Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.8401 19.7288C20.8401 19.7288 22.2521 18.719 22.0724 16.1219C21.8884 13.4563 20.4337 13.0156 20.4337 13.0156C19.6169 13.8434 19.1458 14.9509 19.1158 16.1133C19.1073 18.0772 20.8401 19.7288 20.8401 19.7288Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.2944 22.5565C18.2944 22.5565 20.0058 22.7576 21.6274 20.7081C23.249 18.6587 22.4831 17.3066 22.4831 17.3066C21.3219 17.3735 20.2296 17.8798 19.4282 18.7229C18.1018 20.1819 18.2944 22.5565 18.2944 22.5565Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.1438 19.168L20.0699 20.5542"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.9684 17.6874L20.579 15.4668"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1721_47811">
                    <rect width="27.7126" height="31.3751" fill="white" transform="translate(0.602356 0.675781)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMGlutenFreeActive;

MMGlutenFreeActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMGlutenFreeActive.defaultProps = {
    className: null,
};
